export const PorangeCheckmark = () => {
    return (
        <span className="flex-shrink-0 w-5 h-5 rounded-full 
								bg-gradient-dark-porange flex items-center justify-center">
            <svg
                width="12"
                height="12"
                viewBox="0 0 12 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 3L4.5 8.5L2 6"
                    stroke="white"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        </span>
    );
};